export default {
  'home.emptyListHeading': 'Seems you don’t have acces to any application',
  'home.errorRequestHeading': 'Oops! Something went wrong…',
  'home.emptyListText': 'Please contact your supervisor/line manager.',
  'home.errorRequestText': 'The application has encountered an unknown error.',
  'home.lastAccessTime': 'Last accessed { value }'
};
